module.exports = __webpack_public_path__ + "static/media/truck.f4800551.svg";